import { render, staticRenderFns } from "./SetupOtpPopup.vue?vue&type=template&id=171376c0&scoped=true"
import script from "./SetupOtpPopup.vue?vue&type=script&lang=js"
export * from "./SetupOtpPopup.vue?vue&type=script&lang=js"
import style0 from "./SetupOtpPopup.vue?vue&type=style&index=0&id=171376c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171376c0",
  null
  
)

export default component.exports